import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import {CdkVirtualScrollViewport} from "@angular/cdk/scrolling";
import {AgentRouteScoreModel} from "../../../../agents/angular/models/agent-route-score.model";
import {AgentModel} from "../../../../agents/angular/models/agent.model";
import {TaskModel} from "../../../../tasks/models/task.model";
import {AgentReference} from "../../../../agents/angular/models/agentReference.model";
import * as moment from "moment";
import {TaskType} from "../../../../tasks/types/task.type";

require('./dashboard-agents-route-score-table.scss');
@Component({
  standalone: false,
  selector: 'app-dashboard-agents-route-score-table',
  templateUrl: './dashboard-agents-route-score-table.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DashboardAgentsRouteScoreTableComponent implements OnChanges, AfterViewInit {

  @Input() agentsRouteScore: AgentRouteScoreModel[];
  @Input() dateRange: any;
  @Output() fetchNextEvent = new EventEmitter<null>();

  @ViewChild('header', {static: false}) header: ElementRef;
  @ViewChild(CdkVirtualScrollViewport, {static: false})
  private cdkVirtualScrollViewport: CdkVirtualScrollViewport;

  constructor(@Inject('agentDialogService') private agentDialogService, @Inject('reportsDialogService') private reportsDialogService, @Inject('reportsRequests') private reportsRequests) {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.agentRouteScores) {
      this.cdkVirtualScrollViewport?.checkViewportSize();
    }
  }

  getNextBatch() {
    if (this.cdkVirtualScrollViewport.measureScrollOffset('bottom') < 50) {
      this.fetchNextEvent.emit();
    }
  }

  onViewAgentTasks(agent: AgentModel, tasks: any[], plannedTasksOrder: string[], actualTasksOrder: string[]) {

    const tasksCopy = [...tasks];

    const stopoverPlannedTasksOrder = plannedTasksOrder.filter((taskId) => {
      const task = tasksCopy.find(t => t.id === taskId);
      if (task.taskType !== TaskType.Internal) {
        return taskId;
      }
    })

    stopoverPlannedTasksOrder.forEach((id, index) => {
      const task = tasksCopy.find(t => t.id === id);
      task.index = index;
    });

    const orderedTasks = tasksCopy.sort((a, b) => actualTasksOrder.indexOf(a.id) - actualTasksOrder.indexOf(b.id));

    this.agentDialogService.viewAgentTasks(agent, orderedTasks, true, {...this.dateRange});
  }

  onViewAgentRoutePerformance(agentRef: AgentReference) {
    const agentRoutesPerformanceParams = {
      agentId: agentRef.id,
      from: moment().subtract(1, 'week').startOf('day').valueOf(),
      to: moment().subtract(1, 'day').endOf('day').valueOf()
    }
    this.reportsRequests.getAgentRoutesPerformance(agentRoutesPerformanceParams)
      .then((res: any) => {
        this.reportsDialogService.agentRoutesPerformanceDialog(agentRef, res.list, agentRoutesPerformanceParams.from, agentRoutesPerformanceParams.to);
      })
  }

  ngAfterViewInit(): void {
    const div1 = this.header.nativeElement;
    const div2 = this.cdkVirtualScrollViewport.elementRef.nativeElement;

    div2.addEventListener('scroll', (e) => {
      div1.scrollTop = div2.scrollTop;
      div1.scrollLeft = div2.scrollLeft;
    });
  }

}
